<template>
  <v-row justify="center">
    <v-dialog
      v-model="showDialog"
      persistent max-width="700"
      :close-on-content-click="false"
      :activator="selectedElement"
      full-width
      offset-x
    >
      <v-card flat>
        <v-toolbar :color="selectedTaskColor"
                   flat>
          <v-toolbar-title style="color: #ffffff; font-weight: 500;" v-html="returnName()"></v-toolbar-title>
          <div style="margin-left: 10px;">
            <div v-if="eventToEdit.flagged ==='ATTN'"><v-icon dark style="vertical-align: text-top;">mdi-alpha-a-circle</v-icon> </div>
            <div v-if="eventToEdit.flagged ==='PON'"><v-icon dark style="vertical-align: text-top;">mdi-alpha-p-circle</v-icon></div>
            <div v-if="eventToEdit.flagged ==='BOTH'"> <v-icon dark style="vertical-align: text-top;">mdi-alpha-a-circle</v-icon><v-icon dark style="vertical-align: text-top;">mdi-alpha-p-circle</v-icon></div>
          </div>
          <v-spacer></v-spacer>
          <div v-if="!isDisabled">
            <v-tooltip top v-if="!this.adminFlag" color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn @click="unschedule(eventToEdit)" class="text-right ml-3" small icon dark v-on="on">
                  <v-icon color="#ffffff">mdi-calendar-remove-outline</v-icon>
                </v-btn>
              </template>
              <span>Unschedule Task</span>
            </v-tooltip>
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn @click="toggleFlag" class="text-right ml-3" small icon dark v-on="on">
                  <v-icon color="#ffffff">flag</v-icon>
                </v-btn>
              </template>
              <span>Flag Task</span>
            </v-tooltip>
          </div>
          <v-tooltip top color="secondary">
            <template v-slot:activator="{ on }">
              <v-btn v-on:click="$router.push({name: 'TaskManager', params: { page: '/calendar', type: type }})" @click="getTask(eventToEdit.id)" class="text-right ml-3" small icon
                     dark v-on="on">
                <v-icon color="#ffffff">mdi-square-edit-outline</v-icon>
              </v-btn>
            </template>
            <span>Edit Task</span>
          </v-tooltip>
          <v-icon class=" ml-3 icon-separator"></v-icon>
          <v-btn color="white" style="margin-right: 1px;" icon class="text-right ml-3" @click="toggle(), showScheduleDay = false, dayToEdit = null ">
            <v-icon color="#ffffff" size="32">close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <div class="flex-grow-1" v-if="showFlagOptions">

            <v-radio-group v-model="eventToEdit.flagged" row dense>
              <v-radio label="ATTN"
                       color="error"
                       value="ATTN"></v-radio>
              <v-radio label="PON"
                       color="error"
                       value="PON"></v-radio>
              <v-radio label="ATTN & PON"
                       color="error"
                       value="BOTH"></v-radio>
              <v-radio label="No Flag"
                       color="success"
                       value="NONE"></v-radio>
            </v-radio-group>

          </div>
          <div class="flex-grow-1"></div>
          <v-col cols="12" sm="12" style="height:35px">
            Status: {{eventToEdit.status}}
          </v-col>
          <v-col cols="12" sm="12" style="height:35px">
            Region: {{eventToEdit.regionName}}
          </v-col>
          <v-col cols="12" sm="12" style="height:35px" v-if="displayAddress">
            Address: {{eventToEdit.address}}
          </v-col>
          <v-col cols="12" sm="12" style="height:35px" v-if="displayLatLong">
            Latitude & Longitude: {{eventToEdit.latitude}}, {{eventToEdit.longitude}}
          </v-col>
          <div v-if="isDisabled">
            <v-col cols="12" sm="12" style="height:35px">
              ISD: {{eventToEdit.isd}}
            </v-col>
            <v-col cols="12" sm="12" style="height:35px">
              Duration: {{eventToEdit.duration}}
            </v-col>
            <v-col cols="12" sm="12" style="height:35px">
              Start Date: {{eventToEdit.startDate}}
            </v-col>
            <v-col cols="12" sm="12" style="height:35px">
              Completion Date: {{eventToEdit.completionDate}}
            </v-col>

            <v-col cols="12" sm="12" style="height:35px;">
              Crews: {{taskCrews}}
            </v-col>
          </div>
          <div class="flex-grow-1"></div>
          <div v-if="!isDisabled">
            <v-row style="padding:12px">
              <v-col cols="6" sm="6" style="height:75px">
                <v-dialog ref="isdDialog"
                          v-model="isdDateModal"
                          :return-value.sync="eventToEdit.isd"
                          persistent
                          width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="eventToEdit.isd"
                                  label="ISD"
                                  readonly
                                  v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="eventToEdit.isd" type="date" @input="$refs.isdDialog.save(eventToEdit.isd)"
                                 scrollable>
                    <div class="flex-grow-1"></div>
                    <v-btn text color="accent" @click="isdDateModal = false">Cancel</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="6" sm="6" style="height:75px">
                <v-text-field placeholder
                              v-model="eventToEdit.duration"
                              label="Duration"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" sm="6" style="height:75px">
                <v-dialog ref="startDialog"
                          :return-value.sync="eventToEdit.startDate"
                          persistent
                          width="290px"
                          v-model="startDateModal">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="eventToEdit.startDate"
                                  label="Start Date"
                                  readonly
                                  v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-if="eventToEdit.startDate !== defaultTimeStamp" v-model="eventToEdit.startDate" type="date" @input="$refs.startDialog.save(eventToEdit.startDate)"
                                 scrollable>
                    <div class="flex-grow-1"></div>
                    <v-btn text color="accent" @click="startDateModal = false">Cancel</v-btn>
                  </v-date-picker>
                  <v-date-picker v-else-if="eventToEdit === defaultTimeStamp" v-model="today" type="date" @input="$refs.startDialog.save(eventToEdit.startDate)"
                                 scrollable>
                    <div class="flex-grow-1"></div>
                    <v-btn text color="accent" @click="startDateModal = false">Cancel</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <div class="flex-grow-1"></div>
              <v-col cols="6" sm="6" style="height:75px">
                <v-dialog ref="endDialog"
                          v-model="endDateModal"
                          :return-value.sync="eventToEdit.completionDate"
                          persistent
                          width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="eventToEdit.completionDate"
                                  label="Completion Date"
                                  readonly
                                  v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-if="eventToEdit.completionDate !== defaultTimeStamp"
                                 v-model="eventToEdit.completionDate"
                                 type="date"
                                 @input="$refs.endDialog.save(eventToEdit.completionDate)"
                                 scrollable>
                    <div class="flex-grow-1"></div>
                    <v-btn text color="accent" @click="endDateModal = false">Cancel</v-btn>
                  </v-date-picker>
                  <v-date-picker v-else-if="eventToEdit === defaultTimeStamp"
                                 v-model="today"
                                 type="date"
                                 @input="$refs.endDialog.save(eventToEdit.completionDate)"
                                 scrollable>
                    <div class="flex-grow-1"></div>
                    <v-btn text color="accent" @click="endDateModal = false">Cancel</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
            </v-row>
            <div class="flex-grow-1"></div>
            <div class="flex-grow-1"></div>
            <v-col cols="12" sm="12" style="height:75px; padding-left:0px; padding-right:0px;">
              <v-select label="Crew Name / Number"
                        :items="crews"
                        v-model="addCrewToTask"
                        chips
                        multiple
                        hide-no-data
                        append-icon="mdi-plus"
                        item-text="text"
                        item-value="value">
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip v-bind="attrs"
                          :input-value="selected.value"
                          close
                          @click="select"
                          @click:close="remove(item.value)">
                    <strong>{{ `${item.text}` }}</strong>&nbsp;
                  </v-chip>
                </template>
              </v-select>
            </v-col>
          </div>
          <v-alert v-if="this.preUpdateError !=null" justify-center color="error" dark>
            <v-icon size="20" dark>warning</v-icon>
            {{this.preUpdateError}}
          </v-alert>
          <div><schedule-day></schedule-day></div>
        </v-card-text>
        <v-snackbar v-model="savedMessage" color="success">
          Changes to task saved
          <v-btn icon color="white" style="float:right;" text @click="savedMessage = false">
            <v-icon size="28">mdi-close</v-icon>
          </v-btn>
        </v-snackbar>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ScheduleDay from '@/components/scheduling/ScheduleDay'
export default {
  components: {
    ScheduleDay
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    toggle: {
      type: Function,
      required: true
    },
    selectedElement: {
      type: HTMLElement
    },
    type: String
  },
  data: () => ({
    showFlagOptions: false,
    savedMessage: false,
    adminFlag: true,
    startDateModal: false,
    endDateModal: false,
    isdDateModal: false,
    lastChanged: null,
    status: ['Field', 'Review', 'Complete', 'PreJob', 'Admin'],
    disabled: false,
    preUpdateError: null,
    previousStatus: null,
    crewToAdd: {
      crewId: null,
      taskId: null
    },
    today: new Date(),
    defaultTimeStamp: '0001-01-01T00:00:00',
    eventToEdit: {
      id: null,
      workOrderId: null,
      taskNumber: null,
      start: null,
      end: null,
      color: '#b4b4b4',
      circuitNumber: null,
      crews: {
        name: ''
      },
      region: null,
      regionId: null,
      status: null,
      isd: null,
      completionDate: null,
      startDate: null,
      duration: null,
      flag: null,
      latitude: null,
      longitude: null,
      address: null,
      eso: null,
      description: null,
      flagged: 'NONE'
    }
  }),
  watch: {
    selectedTask(event) {
      event = this.setDates(event)
      this.preUpdateError = null
      this.eventToEdit.id = event.id
      this.eventToEdit.workOrderId = event.workOrderId
      this.eventToEdit.taskNumber = event.taskNumber
      this.eventToEdit.startDate = event.startDate !== this.defaultTimeStamp ? event.startDate.slice(0, 10) : null
      this.eventToEdit.completionDate  = event.completionDate !== this.defaultTimeStamp ? event.completionDate.slice(0, 10) : null
      this.eventToEdit.color = event.color ? event.color : '#b4b4b4'
      this.eventToEdit.regionName= event.region.name
      this.eventToEdit.regionId = event.regionId
      this.eventToEdit.status = event.status
      this.eventToEdit.isd = event.isd ? event.isd.slice(0, 10) : null
      this.eventToEdit.duration = event.duration
      this.eventToEdit.flag = event.flag
      this.eventToEdit.latitude = event.latitude
      this.eventToEdit.longitude = event.longitude
      this.eventToEdit.address = event.address
      this.eventToEdit.eso = event.eso
      this.eventToEdit.description = event.description
      this.eventToEdit.flagged = event.flagged
      /*      if (this.adminFlag === false) {
              let crewsForEdit = null
              if (event.crews) {
                crewsForEdit = event.crews.map(c => {
                  return { text: `${c.value.region.name}-${c.value.name}-${c.value.crewLead.name}`, value: c.value }
                })
              }
              this.eventToEdit.circuitNumber = event.circuitNumber
              this.eventToEdit.crews = crewsForEdit
            } else {
              this.eventToEdit.circuitNumber = null
              this.eventToEdit.crews = []
            }*/
      let crewsForEdit = null
      if (event.crews) {
        crewsForEdit = event.crews.map(c => {
          return { text: `${c.value.name}-${c.value.crewLead.name}`, value: c.value }
        })
      }
      this.eventToEdit.circuitNumber = event.circuitNumber
      this.eventToEdit.crews = crewsForEdit
    },
    eventToEdit: {
      handler() {
        this.preUpdateError = null
        if (this.checkDifference() && (this.eventToEdit.startDate !== this.defaultTimeStamp && this.eventToEdit.completionDate !== this.defaultTimeStamp)) {
          this.update()
        }
      }, deep: true
    }

  },
  methods: {
    ...mapActions({
      updateWorkOrderTask: 'workOrderTask/updateTask',
      removeCrew: 'workOrderTask/removeCrew',
      addCrew: 'workOrderTask/addCrew',
      flagTask: 'workOrderTask/flagTask',
      getTask: 'workOrderTask/getTask',
      updateDay: 'schedule/updateScheduledDay',
      createDay: 'schedule/createScheduledDay',
      deleteScheduleDay: 'schedule/deleteScheduledDay'
    }),
    checkDifference() {
      let isDifferent = false

      //Only need to check these values, Flag has its own save, same with crew change.
      if ((this.eventToEdit.startDate !== this.selectedTask.startDate.slice(0, 10)) && (this.eventToEdit.startDate !== null)) { isDifferent = true }
      if ((this.eventToEdit.completionDate !== this.selectedTask.completionDate.slice(0, 10)) && (this.eventToEdit.completionDate !==null)) { isDifferent = true }
      if (this.eventToEdit.isd !== this.selectedTask.isd.slice(0, 10)) { isDifferent = true }
      if (this.eventToEdit.duration !== this.selectedTask.duration) { isDifferent = true }
      if (this.eventToEdit.flagged !== this.selectedTask.flagged) { isDifferent = true }
      return isDifferent

    },

    returnName () {
      var name = 'Work Order'
      if (this.selectedTask != null) {
        name = this.selectedTask.name
      }
      return name
    },
    async update() {
      this.disabled = true
      try {
        this.checkForErrors()
        if (!this.preUpdateError) {
          await this.updateWorkOrderTask( this.eventToEdit)
        }
        if (!this.error && !this.preUpdateError) {
          this.savedMessage = true
          await this.addScheduleDay() // If it saves, check if there are schedule days, if not add them
        }
      } catch (error) {
        this.preUpdateError = error.message
      }
      this.disabled = false
    },
    async unschedule() {
      if (this.schedule.length > 0) {
        this.schedule.forEach(async d =>
          await this.deleteScheduleDay(d.id)
        )
      }
      this.eventToEdit.startDate = this.defaultTimeStamp
      this.eventToEdit.completionDate = this.defaultTimeStamp
      await this.updateWorkOrderTask(this.eventToEdit)
    },
    async remove (item) {
      let crewToRemove = ({ crewId: item.id, taskId: this.eventToEdit.id })
      this.eventToEdit.crews.map(crew => {
        const index = this.eventToEdit.crews.indexOf(crew)
        if (index >= 0) this.eventToEdit.crews.splice(index, 1)
      })
      await this.removeCrew(crewToRemove)
      if (!this.error) { this.savedMessage = true}
    },
    checkForErrors () {
      let endDate = new Date(this.eventToEdit.completionDate)
      let startDate = new Date(this.eventToEdit.startDate)
      if (endDate < startDate) {
        this.preUpdateError = 'Error! Start Date After Completion Date'
        this.disabled = true
      } else if (!this.checkDates()) {
        this.preUpdateError = 'Error! Schedule days must fall within start & completion days'
        this.disabled = true
      } else {
        this.preUpdateError = null
        this.disabled = false
      }
    },
    setDates (event) {
      // TODO: Why are we passing around to different values names
      // Calendar calls for "start" and "end" variables to set events in the Calendar, startDate & completionDates are variables we have added to the Task
      // With Schedule Days now, a task will get split into multiple "events" with start and end times, but the same overall task startDate & completionDate
      // Set start and end for date pickers
      event.start =  event.start || event.startDate
      event.end = event.end || event.completionDate
      // Disable crew manage if the sites are default
      this.adminFlag = (event.start === this.defaultTimeStamp && event.end === this.defaultTimeStamp)
      // Set defaults dates to today for date pickers
      event.start = this.adminFlag ? new Date().toISOString().slice(0, 10) : event.start
      event.end = this.adminFlag ? new Date().toISOString().slice(0, 10) : event.end

      return event
    },
    checkDates() {
      let valid = true

      if (this.eventToEdit.startDate !== null && this.eventToEdit.completionDate !== null) {
        let endDate = new Date(this.eventToEdit.completionDate.slice(0, 10))
        let startDate = new Date(this.eventToEdit.startDate.slice(0, 10))

        this.schedule.forEach(d => {
          let day = new Date(d.start.slice(0, 10))

          if (startDate > day) { valid = false }
          if (endDate < day) { valid = false }

          let secondDay = new Date(d.end.slice(0, 10))

          if (day !== secondDay) {
            if (startDate > secondDay) { valid = false }
            if (endDate < secondDay) { valid = false}
          }
        })
      }

      return valid
    },
    async addScheduleDay() {
      if (this.schedule.length === 0) {
        if (this.eventToEdit.startDate !== null && this.eventToEdit.completionDate !== null) {
          let schedule = {}
          if (this.eventToEdit.startDate.slice(0, 10) === this.eventToEdit.completionDate.slice(0, 10)) {
            schedule = {
              note: null,
              crewId: null,
              start: this.eventToEdit.startDate.slice(0,10)+ 'T' + this.getDefaultTimes.start,
              end: this.eventToEdit.startDate.slice(0, 10) + 'T' + this.getDefaultTimes.end,
              workOrderTaskId: this.eventToEdit.id
            }
          } else {
            schedule = {
              note: null,
              crewId: null,
              start: this.eventToEdit.startDate.slice(0,10)+ 'T'+ this.getDefaultTimes.none,
              end: this.eventToEdit.completionDate.slice(0, 10) + 'T' + this.getDefaultTimes.none,
              workOrderTaskId: this.eventToEdit.id
            }
          }
          await this.createDay(schedule)
        }
      }
    },
    toggleFlag() {
      this.showFlagOptions = !(this.showFlagOptions)
    }
  },
  computed: {
    ...mapGetters({
      regions: 'region/selectList',
      crewLeads: 'crew/selectCrewLeadAndCrew',
      error: 'workOrderTask/error',
      crews: 'crew/crewsForTasks',
      selectedCrew: 'workOrderTask/selectedCrewTask',
      selectedTask: 'workOrderTask/selectedTask',
      selectedTaskColor: 'workOrderTask/selectedTaskColor',
      userRole: 'user/role',
      searchObject: 'workOrderTask/searchObject',
      schedule: 'schedule/scheduleByTask',
      getDefaultTimes: 'schedule/getDefaultTimes'
    }),
    workOrderNumber: {
      get () {
        if (this.selectedTask != null) {
          return this.selectedTask.workOrder.workOrderNumber
        } else {
          return ''
        }
      }
    },
    crewSelected: {
      get () {
        return this.selectedCrew.map(c => {
          return {
            text: (`${this.selectedTask.workOrder.region.name}-${c.crew.name}-${c.crew.crewLead.firstName}`),
            value: c.crew
          }
        })
      },
      set (crew) {
        this.crewToAdd.crewId = crew.id
        this.crewToAdd.taskId = this.selectedTask.id
      }
    },
    taskCrews () {
      let text = ''
      this.selectedCrew.map(c => {
        text += `${c.crew.name} - ${c.crew.crewLead.firstName} | `
      })
      return text
    },
    addCrewToTask: {
      get() {
        return this.eventToEdit.crews
      },
      set (value) {
        if (value.length > this.eventToEdit.crews.length) {
          this.crewToAdd.crewId = value[value.length - 1].id
          this.crewToAdd.taskId = this.eventToEdit.id
          this.addCrew(this.crewToAdd)
          if (!this.error) { this.savedMessage = true}
          this.eventToEdit.crews = value
        }
      }
    },
    isDisabled () {
      if (this.userRole === 'Sub Foreman') {
        return true
      } else {
        return false
      }
    },
    displayAddress() {
      const address = this.eventToEdit.address
      return !(!address || address.length === 0)
    },
    displayLatLong () {
      if (this.eventToEdit.latitude !== 0 && this.eventToEdit.longitude !== 0) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
<style scoped>
.icon-separator:after {
  content: "";
  height: 32px;
  border-left: 1px solid #ffffff;
}
.date-button {
  padding-top: 5px !important;
  padding-bottom: 5px!important;
  height: 38px !important;
}
</style>
